import { render, staticRenderFns } from "./layout-product-tabs.vue?vue&type=template&id=72ba544c&scoped=true"
import script from "./layout-product-tabs.vue?vue&type=script&lang=js"
export * from "./layout-product-tabs.vue?vue&type=script&lang=js"
import style0 from "./layout-product-tabs.vue?vue&type=style&index=0&id=72ba544c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ba544c",
  null
  
)

export default component.exports